import { BidPlaceErrorCode } from '../types/trade';

const bidPlaceErrorCodeToMessageId = (errorCode: number) => {
  switch (errorCode) {
    case BidPlaceErrorCode.UNAUTHORIZED:
      return 'bidding.error.unauthorized';
    case BidPlaceErrorCode.INVALID_AMOUNT:
      return 'bidding.error.invalidAmount';
    case BidPlaceErrorCode.TOO_LOW:
    case BidPlaceErrorCode.COLLISION:
    case BidPlaceErrorCode.PROXY_TOO_LOW:
    case BidPlaceErrorCode.AMOUNT_SAME_AS_PROXY:
      return 'bidding.error.someoneElseBid';
    default:
      return 'vdp.error.placingBid';
  }
};

export default bidPlaceErrorCodeToMessageId;
